import StepBody from "../StepBody";
import ReportForm from "./ReportForm";
import { useReport } from "./ReportProvider";

const ReportPage = () => {
  const reporting = useReport();

  if (!reporting?.origin) {
    return null;
  }

  const { area } = reporting.origin;

  return reporting.canReport(area) ? (
    <ReportForm area={area} />
  ) : (
    <StepBody>
      <h1 className="text-title text-ink text-balance">Report a problem</h1>
      <p className="text-body text-ink-secondary">
        Feedback is currently unavailable. Please go back and continue.
      </p>
    </StepBody>
  );
};

export default ReportPage;
